// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607270014/js/" + chunkId + "." + {"44":"34eff101","225":"3fa038b3","481":"be838b20","486":"576e40c4","770":"bc55078d"}[chunkId] + ".0.10612115902246.chunk.js";
};